import React from 'react';
import { IEditForm } from '../../types/interfaces/IEditForm';
import { Typography, Box, Switch } from '@material-ui/core';

const SwitchInput: React.FC<IEditForm> = ({ onChange, value, fieldName, label, disabled = false }) => {
  return (
    <Box display="flex">
      <Box marginRight={1} fontWeight="bold">
        <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
          {label}
        </Typography>
      </Box>
      <Switch checked={value} disabled={disabled} onClick={() => (onChange ? onChange(fieldName, !value) : null)} />
    </Box>
  );
};

export default SwitchInput;
